export const METRICS = {
  BANNER_CHECK: 'checkForCookieConsent',
  BANNER_SHOW: 'bannerShown',
  UI_MOUNTED: 'uiMounted',
  CLICK_ACCEPT_ON_BANNER: 'acceptAll',
  CLICK_DECLINE_ON_BANNER: 'decline',
  SAVE_CUSTOMISED_COOKIE: 'customize',
  CANCEL_CUSTOMISED_COOKIE: 'cancel',
  MANNUAL_OPEN_PREFERENCE_MODAL: 'customizeCookies',
  MANUAL_OPEN_CCBA_MODAL: 'customizeCCBA',
  CHECK_GEOLOCATION_SUCCESS: 'geolocationLatency',
  CHECK_COUNTRY_POLICIES_LATENCY: 'getCountryPoliciesLatency',
  CHECK_COUNTRY_POLICIES_ATTEMPT: 'getCountryPoliciesAttempt',
  SAVED_COOKIE: 'SaveConsentClicked',
};

export const TELEMETRY_TOKEN = {
  AWS: {
    PROD: "v1/9f5686a423270882693358982d9633c38dce8ce8a428936aa03c6ae420d332ce",
    GAMMA: "v1/e79f94465ef88edeff2eca4a76f97feaceb56490c3b06e8b0eacca1598958fab",
    BETA: "v1/f98974f7e8c3e20c9a3d2869bfb3414cf1a377d5f970cb6b4488ccc353dc9ecc"
  },
  ESC: {
    PROD: "v1/6faf86d25ce66c45fe623b16fd3667452a74cc9672bc0187d5fdf4e21179c5e7",
    GAMMA: "v1/d0bcac4b35cdea524008a1d4feb0028df4642ae069c38660cc52cdf7c1ef47e9",
    BETA: "v1/55f340570ba892f208aabda2c6e37c2877bc897c0d169f2b71cb880849b39135"
  }
}

export interface TelemetryEventDetail {
  timestamp: number,
  logVersion?: string,
  domain: string,
  url: string,
  latency?: number,
  region?: string,
  [key: string]: any
}

export interface EventDetails {
  metric: string,
  value: number | string,
  unit: string,
  error?: Error,
  details?: string
}

export const UNIT = {
  COUNT: "count",
  MILLISECONDS: "milliseconds"
}